<template>
  <div class="categories">
    <v-card-text >
      <v-row>
<!--        <v-col cols="3" v-for="item in items" :key="item.Id">-->
<!--          <div  >-->
<!--            <div  v-on:click="goToDetail(item.Id)">-->
<!--              <div class="row" style="text-align: center">-->
<!--                <div class="col-12">-->
<!--                  <img style="width: 80%;height: auto;padding: 7px;background: #F3F3F3;border-radius: 10px;" :src="item.ImageUrl" />-->
<!--                </div>-->
<!--                <div class="col-12" style="text-align: center">-->
<!--            <span class="name" style="font-size: 12px;text-align: center;line-height: 1.1rem;color: black;">-->
<!--              {{item.CategoryTitle}}-->
<!--            </span>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </v-col>-->
<!--        <v-col style="padding: 0" cols="4">-->
<!--          <v-row>-->
<!--            <v-col style="padding: 0" cols="12">-->
<!--              <MainBox title="پیام رسان" @click.native="go_to_messenger()" class="messenger main-box  large-box-icon" image="/main_icons/messenger_icon.svg"/>-->
<!--            </v-col>-->
<!--            <v-col style="padding: 0" cols="12">-->
<!--              <MainBox title="کسب و کار" @click.native="goToDetail('XGRZRG5DUGZYBH42YB6ZTK6AS2HHXEF3SSFINBQ')" class="jobs main-box " image="/main_icons/jobs.svg"/>-->
<!--            </v-col>-->
<!--          </v-row>-->
<!--        </v-col>-->
        <v-col cols="6 col-sm-4 col-md-3 col-lg-2" v-for="item in items" :key="item.Id">
          <div >
            <MainBox :title="item.Name" @click.native="goToDetail(item.Id)"
                     :class="last_class_name+' group-box invert-white'" :image="item.Image"/>

          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </div>
</template>
<script>
  import MainBox from '../../components/MainBox'
  import zood_data from "./categories";
  export default {
    components:{
      MainBox
    },
    data () {
      return {
        items:[],
        selected_item_id : '',
        last_class_name : '',
        errors: [],
        rules: {
          required: value => !!value || this.$t('necessary'),
          fullName: value => value.length <= 30 || this.$t('max30Character'),
          PersianFullName: value => {
            const pattern = /^[پچجحخهعغآ؟.،آفقثصضشسیبلاتنمکگوئدذرزطظژ!!ؤإأءًٌٍَُِّ\s]+$/
            return pattern.test(value) || this.$t('nameNotFarsi')
          },
          mobile: value => {
            const pattern = /^(\+98|0098|98|0)?9\d{9}$/
            return pattern.test(value) || this.$t('phoneNotCorrect')
          },
        },
      }
    },
watch: {

    },
mounted () {
      var passing_data = JSON.parse(localStorage.getItem('request_data'))
     this.selected_item_id = passing_data.group_id
  this.last_class_name = passing_data.class_id
      this.get_categories()
    },
    methods: {
      get_item_color (item_id) {
        if (item_id == this.selected_item_id) {
         return '#cee2f7'
        } else {
          return 'white'
        }
      },
      goToDetail (item_id) {
        var passing_data = JSON.parse(localStorage.getItem('request_data'))
        passing_data.group_id = item_id
        localStorage.setItem('request_data', JSON.stringify(passing_data))
        this.$router.push({ path: 'subgroups', params: {} })
      },
      get_categories () {
        // console.log("datas is "+localStorage.getItem('request_data'))
        var self = this
        var passing_data = JSON.parse(localStorage.getItem('request_data'))
        var cat_id = passing_data.cat_id
        console.log('categoris is', zood_data.types[cat_id])

        self.items = zood_data.types[cat_id]
        // const send_data = {
          //   pTypeId: cat_id,
          // }
        // this.axios.post('/GetReqTypeCategoryByTypeId', send_data, {})

        // const send_data = {
        //     type_id: cat_id,
        //   }
        //   // this.axios.post('/Register' , send_data,{
        //   this.axios.post('https://cp.zoodkomak.com/api/category-groups', send_data, {})
        //     .then(response => {
        //       if (response.data.error == 0) {
        //         // console.log("response", response);
        //         // self.fullName = response.data.msg;
        //         self.items = response.data.categories
        //         // self.level = 2;
        //       }
        //       // this.$router.push({ path: "/post-login", params: {} });
        //     }).catch(e => {
        //     this.errors.push(e)
        //   })
      }
    }
  }
</script>
